var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"project-questionaries-container"},[_c('div',[_c('h3',[_vm._v("Proyecto: "+_vm._s(_vm.projectName))])]),_vm._v(" "),_c('div',{staticClass:"questionaries-content"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }